export default __webpack_public_path__ + "submit-success.a7ada9f084d907219a3dd543959a92ea.png";